const authHu = {
    "sign_in": "Bejelentkezés",
    "registration": "Regisztráció",
    "email": "Email cím",
    "password": "Jelszó",
    "invalid_credentials": "Hibás belépési adatok",
    "login_with_google": "Bejelentkezés Google-el",
    "password_min_length": "A jelszónak legalább 8 karakter hosszúnak kell lennie",
    "forgotten_password": "Elfelejtettem a jelszavam",
    "unable_to_reset_password": "Jelszóvisszaállítás sikertelen.",
    "reset_password_title": "Jelszó visszaállítása",
    "reset_password_text": "Kérjük, adja meg az email címét, amellyel regisztrálva lett a rendszerbe. Az email címre elküldjük a jelszó visszaállításához szükséges linket.",
    "send_reset_mail": "Jelszó visszaállító link küldése",
    "send_reset_mail_success": "Az email címre elküldtük a jelszó visszaállításához szükséges linket",
    "invalid_email": "Érvénytelen email cím",
    "reset_sent": "Üzenet elküldve",
    "reset_email_error": "Hiba történt az email küldése közben",
    "server_unavailable": "A szerver nem elérhető",
    "text_is_empty": "A szöveg nem lehet üres",
    "no_restaurant_selected": "Ehhez a felasználóhoz nincsen étterem hozzárendelve. Kérem, vegye fel a kapcsolatot az adminisztrátorral.",
    "password_too_short": "A jelszó túl rövid. Legalább 6 karakter hosszúnak kell lennie.",
    "registration_success": "Sikeres regisztráció! Üdvözlünk a megújult ReservOurs adminban!",
    "registration_failed": "A regisztráció sikertelen. Kérjük, próbálja újra később.",
    "registration_title": "ReservOurs regisztráció",
    "register": "Regisztráció",
    "registration_information": "Kérjük a regisztrációhoz az adminisztrátorral előre egyeztetett email címet, vagy pedig a meghívó címzettjét add meg. Jelszavadnak legalább 6 karakter hosszúnak kell lennie.",
    "email_already_in_use": "Ez az email cím már használatban van. Kérjük, válasszon egy másikat, vagy jelentkezzen be.",
    "invalid_token": "Érvénytelen token. Kérjük, lépj be újra az oldalra.",
}

export default authHu;